import Vue from "vue";
import Router from "vue-router";
import vueCookie from "vue-cookie"

Vue.use(Router);
//comment
// route-level code splitting
const LoginView = () => import("../views/auth/loginView.vue");
const ChangePassword = () => import("../views/auth/ChangePassword.vue");
const ForgotPassword = () => import("../views/auth/ForgotPassword.vue");
const RefillBooking=()=>import("../views/buparefill/refill-booking/RefillBooking.vue")
const BupaBrowse=()=>import("../views/buparefill/refill-booking/BupaBrowse.vue")
const BupaAddDetails=()=>import("../views/buparefill/refill-booking/BupaAddDetails.vue")
const RefillAppointment=()=>import("../views/buparefill/refill-appointments/RefillAppointment.vue")
const RefillAbandoned=()=>import('../views/buparefill/refill-abandoned/RefillAbandoned.vue')
const LabSchedules=()=>import('../views/labschedules/LabSchedules.vue')
const BupaLabSchedules = () => import('../views/bupaLabSchedules/BupaLabSchedules.vue')
const router = new Router({
    mode: "history",
    fallback: false,
    scrollBehavior: () => ({ y: 0 }),
    routes: [
      { path: "/", redirect: "/login",name:"login" },
      { path: "/login", component: LoginView, name: "login", props: true },
      {path:"/refill-booking/:action?",component:RefillBooking, name:"refill-booking", meta:{auth:true}},
      {path:"/bupa-browse/:action?",component:BupaBrowse, name:"bupa-browse", meta:{auth:true}},
      {path:"/bupa-add-details/:action?",component:BupaAddDetails, name:"bupaadddetails", meta:{auth:true}},
      {path:"/refill-appointment/:action?/:ref_id?",component:RefillAppointment, name:"refillappointment", meta:{auth:true}},
      {path:"/refill-abandoned/:action?/:appid?",component:RefillAbandoned, name:"refillabandoned", meta:{auth:true}},
      {
        path: "/change-password",
        component: ChangePassword,
        name: "change-password"
      },{
        path: "/forgot-password",
        component: ForgotPassword,
        name: "forgot-password",
        meta: {
          auth: true
        }
      },
      {path:"/lab-schedules/:action?/:bupa_lab_id?" , component:LabSchedules, name:"LabSchedules" },
      {path:"/bupa-lab-schedule/:action?/:id?" , component: BupaLabSchedules, name: "BupaLabSchedules"}


      //{ path: "*", component: PageNotFound },
    ]
  });
  router.beforeResolve ((to, from, next) => {
   if(from.name && from.name.toLocaleLowerCase()!="rateandreview"){
    localStorage.setItem('pageNumber','1')
   }
    let token = vueCookie.get('token')
    if(token){
      let status = true;
      router.app.$store.dispatch('auth/UPDATE_LOGIN',{status, token})
    }else{
      let token = null, status = false;
      router.app.$store.dispatch('auth/UPDATE_LOGIN',{status, token})
    }
    if (router.app.$store) {
      const isAuthRequired = to.meta.auth;
      let _token = router.app.$store.getters['auth/getToken'];
      if(isAuthRequired && !_token){
        setTimeout(function(){
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          if (to.name == 'forgot-password') {
            return next({
              name: 'forgot-password'
            })
          }
          else if (to.name == 'set-password') {
            return next({
              name: 'set-password'
            })
          }
          else {
            return next({
              name: 'login'
            })
          }
        },100)
      }
      if (to.name === 'login' && _token){
        setTimeout(function(){
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          return next({name:'dashboard'})
        },100)
      }if (to.name === 'forgot-password' && _token) {
        setTimeout(function () {
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          return next({
            name: 'dashboard'
          })
        }, 100)
      }
      if (to.name === 'set-password' && _token) {
        setTimeout(function () {
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          return next({
            name: 'dashboard'
          })
        }, 100)
      }
      else{
        router.app.$store.dispatch("SET_LAYOUT", to.name);
        return next()
      }
    }
    router.app.$store.dispatch("SET_LAYOUT", to.name);
    return next()
  });
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js